<span
  class="font-semibold text-ui-dark text-xl inline-flex items-center py-1 cursor-pointer"
  (click)="openSheet()"
>
  {{ header() }}
  <i class="text-2xl icon-arrow_down ml-1"></i>
</span>
